










































































































import { Component, Vue } from "vue-property-decorator";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import store from "@/shared/core/store";

interface HomeHeroSlide {
  image: string;
  title: string;
  subtitle: string;
  badgeText: string;
  badgeUrl: string;
  textColor: string;
}

@Component({
  components: { VueSlickCarousel },
})
export default class HomeHero extends Vue {
  slides: HomeHeroSlide[] = [];
  template: any = null;
  activeIndex: number = 0;
  carouselSettings: any = {
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1200,
    autoplaySpeed: 5000,
    cssEase: "ease-in-out",
    fade: true,
  };

  async mounted() {
    await this.loadSlides();
  }

  get activeSlide() {
    if (this.slides.length === 0) return null;
    return this.slides[this.activeIndex] || this.slides[0] || null;
  }

  get firstSlide() {
    if (this.template == null) return null;
    return this.makeSlide(this.template, 1);
  }

  slideValue(key: string): string {
    const active: any = this.activeSlide;
    if (active && active[key]) return active[key];
    const first: any = this.firstSlide;
    if (first && first[key]) return first[key];
    return "";
  }

  get hasCustomContent() {
    return !!(
      this.slideValue("title") ||
      this.slideValue("subtitle") ||
      this.slideValue("badgeText")
    );
  }

  get heroTitle() {
    const value = this.slideValue("title");
    if (value) return value;
    return this.hasCustomContent ? "" : String(this.$t("Home Hero Title"));
  }

  get heroSubtitle() {
    const value = this.slideValue("subtitle");
    if (value) return value;
    return this.hasCustomContent ? "" : String(this.$t("Home Hero Subtitle"));
  }

  get badgeText() {
    const value = this.slideValue("badgeText");
    if (value) return value;
    return this.hasCustomContent ? "" : String(this.$t("Explore more"));
  }

  get badgeTextRing() {
    const text = String(this.badgeText || "").trim();
    if (!text) return "";
    const chunk = text + " ・ ";
    return chunk.length > 22 ? chunk : chunk + chunk;
  }

  get badgeHref() {
    return this.slideValue("badgeUrl") || "#about";
  }

  get badgeTarget() {
    return this.isExternalUrl(this.badgeHref) ? "_blank" : null;
  }

  get badgeRel() {
    return this.isExternalUrl(this.badgeHref) ? "noreferrer" : null;
  }

  get heroStyle() {
    const color = this.slideValue("textColor") || "#ffffff";
    return { "--hero-text-color": color };
  }

  onAfterChange(current: any) {
    if (typeof current === "number") {
      this.activeIndex = current;
      return;
    }
    if (current && typeof current.currentSlide === "number") {
      this.activeIndex = current.currentSlide;
    }
  }

  nextSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
  }

  prevSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
  }

  async loadSlides() {
    const url = `${Settings.HostName}/api/czconfigs/template`;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.data == null || !data.ok) {
      console.error("Crash getting hero slides");
      return;
    }
    this.template = data.data;
    this.slides = this.buildSlides(data.data);
    this.activeIndex = 0;
  }

  makeSlide(data: any, index: number): HomeHeroSlide {
    const base = store.state.settings.Uploads || "";
    const image = data[`image${index}`];
    const left = data[`textSlideInLeft${index}`] || "";
    const up = data[`textSlideInUp${index}`] || "";
    const title = [left, up].filter((part) => part).join(" ").trim();
    return {
      image: image ? base + "/" + image : "",
      title: title,
      subtitle: data[`textSmall${index}`] || "",
      badgeText: data[`textButton${index}`] || "",
      badgeUrl: data[`urlButton${index}`] || "",
      textColor: data[`textColor${index}`] || "",
    };
  }

  buildSlides(data: any) {
    const slides: HomeHeroSlide[] = [];
    [1, 2, 3].forEach((index) => {
      if (!data[`image${index}`]) return;
      slides.push(this.makeSlide(data, index));
    });
    return slides;
  }

  isExternalUrl(value: string) {
    if (!value) return false;
    return /^https?:\/\//i.test(value);
  }
}
